<div class="radio-input-wrapper">
  <!-- Description text -->
  @if (description() || descriptionKey()) {
    <p class="radio-input-wrapper__description">
      @if (description()) {
        {{ description() }}
      } @else {
        {{ (descriptionKey() || '') | translate }}
      }
    </p>
  }

  <!-- Radio options -->
  <div
    class="radio-input"
    [class.radio-input--horizontal]="direction() === 'horizontal'"
    [class.radio-input--vertical]="direction() === 'vertical'">
    @for (option of options(); track option.value) {
      <label
        class="radio-input__option"
        [class.radio-input__option--selected]="isSelected(option.value)"
        [class.radio-input__option--disabled]="isOptionDisabled(option)">
        <!-- Custom radio button -->
        <span class="radio-input__button">
          <input
            type="radio"
            class="radio-input__native"
            [name]="name()"
            [value]="option.value"
            [checked]="isSelected(option.value)"
            [disabled]="isOptionDisabled(option)"
            [attr.aria-label]="option.label || option.labelKey"
            [attr.aria-required]="required()"
            (change)="onRadioChange(option.value)"
          />
          <span class="radio-input__indicator"></span>
        </span>

        <!-- Label text -->
        <span class="radio-input__label">
          @if (option.label) {
            {{ option.label }}
          } @else {
            {{ option.labelKey | translate }}
          }
        </span>
      </label>
    }
  </div>
</div>
